import Reveal from "./Reveal";
import MeshBg from "./MeshBg";

export default function PageHero({ kicker, title, intro = [], variant = "default" }) {
  const paras = Array.isArray(intro) ? intro : [intro];
  return (
    <section className="relative overflow-hidden pt-16 md:pt-24 pb-10 md:pb-14 border-b border-slate-100">
      <MeshBg variant={variant} />
      <div className="container-x">
        <Reveal>
          <span className="overline">{kicker}</span>
        </Reveal>
        <Reveal delay={0.05}>
          <h1 className="mt-5 max-w-4xl text-4xl md:text-6xl font-extrabold tracking-tight leading-[1.05]">
            {title}
          </h1>
        </Reveal>
        {paras.length > 0 && paras[0] && (
          <Reveal delay={0.1}>
            <div className="mt-7 max-w-3xl space-y-4">
              {paras.map((p, i) => (
                <p key={i} className="lead">
                  {p}
                </p>
              ))}
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
